import React from "react";
import { Table, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CaSideNav from "../../../components/AdminComponents/CaSideNav";
import { CourseTopLevelCA } from "../../../components/AdminComponents/MenuItems";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import useCommonListing from "../../../components/AdminComponents/customHooks/useCommonListing";
import { GetFormattedDateTime } from "../../../components/utils/DateTimeUtils";

const QuizListingCA = () => {
  const navigate = useNavigate();
  const userInfo = useSelector((state) => state.user);

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/learn/quizlist/?organization_id=${userInfo?.data?.organization?.id}`,
  });

  const { pageSize, currentPage } = filterData;

  const columns = [
    {
      title: "Quiz Name",
      dataIndex: "quiz_name",
      key: "quiz_name",
      width: 200,
      render: (text) => (
        <span style={{ color: "#1890ff", fontWeight: 500 }}>{text}</span>
      ),
    },
    {
      title: "Course ID",
      dataIndex: "courses",
      key: "course_id",
      width: 120,
      render: (courses) => courses?.map((c) => c.course_id).join(", ") || "—",
    },
    {
      title: "Course Name",
      dataIndex: "courses",
      key: "courses_name",
      width: 250,
      render: (courses) => courses?.map((c) => c.name).join(", ") || "—",
    },
    {
      title: "Passing Score",
      dataIndex: "passing_score",
      key: "passing_score",
      width: 120,
      align: "center",
      render: (score) => (score !== null ? `${score}%` : "—"),
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: GetFormattedDateTime,
    },
  ];

  return (
    <CaSideNav props={CourseTopLevelCA}>
      <CommonTopDetails
        title="Quiz Management"
        titleSuffix={`${itemsLength || 0} quiz(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={true}
        filterAction={false}
        paddingInlinepass="10px"
        addButtonProps={{
          modalType: "Redirect",
          redirctlink: "/ca-admin/trainery-learn/quiz/add",
        }}
      />

      <Table
        columns={columns}
        dataSource={data}
        rowKey="quiz_id"
        size="small"
        loading={loading}
        className="table-container"
        style={{ margin: "1rem" }}
        pagination={false}
        bordered
        onRow={(record) => ({
          onClick: () =>
            navigate(`/ca-admin/trainery-learn/quiz/edit/${record.quiz_id}`),
          style: { cursor: "pointer" },
        })}
      />

      <div
        style={{ display: "flex", justifyContent: "flex-end", padding: "1rem" }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["10", "20", "50"]}
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </CaSideNav>
  );
};

export default QuizListingCA;
